export default "__VITE_PUBLIC_ASSET__9f9fa469__"